import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { firewallServicesSelector } from '../selectors/dashboardSelector';
import { getFirewallServicesStatusRequest } from '../actions/dashboardActions';
import FirewallServicesStatus from '../components/FirewallServicesStatus/FirewallServicesStatus';

const mapStateToProps = createStructuredSelector({ firewallServices: firewallServicesSelector });
const mapDispatchToProps = { getFirewallServicesStatusRequest };

export default connect(mapStateToProps, mapDispatchToProps)(FirewallServicesStatus);
